import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Récupérer la clé reCAPTCHA depuis les variables d'environnement
const loadRecaptcha = (siteKey) => {
  if (siteKey) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  } else {
    console.warn("reCAPTCHA site key is not available.");
  }
};

const RootComponent = () => {

  useEffect(() => {
    fetch('/api/config')
      .then(response => response.json())
      .then(data => {
        loadRecaptcha(data.RECAPTCHA_SITE_KEY);
      })
      .catch(error => console.error("Error fetching reCAPTCHA key:", error));
  }, []);

  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
